module.exports = __webpack_public_path__ + "static/media/create-survey.2f2f9951.png";